module.exports = __webpack_public_path__ + "img/people5.401188d4.png";